import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"
import { connect } from "react-redux"
import withRouter from "components/Common/withRouter"

//i18n
import { withTranslation } from "react-i18next"
import SidebarContent from "./SidebarContent"

import { Link } from "react-router-dom"

import logo from "../../assets/images/logo.svg"
import logoLightPng from "../../assets/images/logo-light.png"
import logoLightSvg from "../../assets/images/logo-light.svg"
// import logoDark from "../../assets/images/logo-dark.png"
import philgepsLogo from "../../assets/images/philgeps-logo.png"

const Sidebar = props => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <NavBarBrandBox className="navbar-brand-box">
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={philgepsLogo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <LogoWrapper>
                <img src={philgepsLogo} alt="" height="46" width="84" />
                <StyledH3>PS-PhilGEPS</StyledH3>
              </LogoWrapper>
            </span>
          </Link>

          <Link
            to="/"
            className="logo logo-light"
            style={{ color: "#fff", fontSize: 17 }}
          >
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <LogoWrapper>
                <img src={philgepsLogo} alt="" height="46" width="84" />
                <StyledH3>PS-PhilGEPS</StyledH3>
              </LogoWrapper>
            </span>
          </Link>
        </NavBarBrandBox>
        <div data-simplebar className="h-100">
          {props.type !== "condensed" ? <SidebarContent /> : <SidebarContent />}
        </div>
        <div className="sidebar-background">{""}</div>
      </div>
    </React.Fragment>
  )
}

const NavBarBrandBox = styled.div`
  padding: 1rem 1rem;
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const StyledH3 = styled.h3`
  font-size: 20px;
  color: #212121;
`

Sidebar.propTypes = {
  type: PropTypes.string,
}

const mapStatetoProps = state => {
  return {
    layout: state.Layout,
  }
}
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)))
